// @ts-strict
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  SohoDataGridComponent,
  SohoDataGridToggleRowEvent,
} from 'ids-enterprise-ng';

@Component({
  selector: 'lm-list-datagrid-soho',
  standalone: false,
  templateUrl: './lm-list-datagrid-soho.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LMListDatagridSohoComponent {
  @ViewChild('SohoDataGrid') sohoDataGridComponent: SohoDataGridComponent;

  @Input() dataGridId: string;
  @Input() dataGridAutomationId: string;
  @Input() gridOptions: SohoDataGridOptions;
  @Input() emptyMessage: SohoEmptyMessageOptions;
  @Input() htmlClasses: string;
  @Input() dataset: any[];

  @Output() cellchange = new EventEmitter<SohoDataGridCellChangeEvent>();
  @Output() rowAdd = new EventEmitter<SohoDataGridAddRowEvent>();
  @Output() closeFilterRow = new EventEmitter<SohoDataGridOpenFilterRowEvent>();
  @Output() openFilterRow = new EventEmitter<SohoDataGridOpenFilterRowEvent>();
  @Output() contextMenu = new EventEmitter<SohoDataGridRowClicked>();
  @Output() entereditmode = new EventEmitter<SohoDataGridEditModeEvent>();
  @Output() filtered = new EventEmitter<SohoDataGridFilteredEvent>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() keydown = new EventEmitter<SohoDataGridKeyDownEvent>();
  @Output() rendered = new EventEmitter<SohoDataGridRenderedEvent>();
  @Output() rowActivated = new EventEmitter<SohoDataGridRowActivated>();
  @Output() rowDeactivated = new EventEmitter<SohoDataGridRowActivated>();
  @Output() rowClicked = new EventEmitter<SohoDataGridRowClicked>();
  @Output() rowDoubleClicked = new EventEmitter<SohoDataGridRowClicked>();
  @Output() selected = new EventEmitter<SohoDataGridSelectedEvent>();
  @Output() settingsChanged = new EventEmitter<SohoDataGridSettingsChangedEvent>();
  @Output() sorted = new EventEmitter<SohoDataGridSortedEvent>();
  @Output() filteroperatorchanged = new EventEmitter<SohoDataGridFilterOperatorChangedEvent>();
  @Output() expandrow = new EventEmitter<SohoDataGridToggleRowEvent>();
  @Output() collapserow = new EventEmitter<SohoDataGridToggleRowEvent>();

  onCellChange(event: SohoDataGridCellChangeEvent): void {
    this.cellchange.emit(event);
  }

  onRowAdd(event: SohoDataGridAddRowEvent): void {
    this.rowAdd.emit(event);
  }

  onCloseFilterRow(event: SohoDataGridOpenFilterRowEvent): void {
    this.closeFilterRow.emit(event);
  }

  onOpenFilterRow(event: SohoDataGridOpenFilterRowEvent): void {
    this.openFilterRow.emit(event);
  }
  
  onContextMenu(event: SohoDataGridRowClicked): void {
    this.contextMenu.emit(event);
  }

  onEnterEditMode(event: SohoDataGridEditModeEvent): void {
    this.entereditmode.emit(event);
  }

  onFiltered(event: SohoDataGridFilteredEvent): void {
    this.filtered.emit(event);
  }

  onKeyDown(event: SohoDataGridKeyDownEvent): void {
    this.keydown.emit(event);
  }

  onRendered(event: SohoDataGridRenderedEvent): void {
    this.rendered.emit(event);
  }

  onRowActivated(event: SohoDataGridRowActivated): void {
    this.rowActivated.emit(event);
  }

  onRowDeactivated(event: SohoDataGridRowActivated): void {
    this.rowDeactivated.emit(event);
  }

  onRowClicked(event: SohoDataGridRowClicked): void {
    this.rowClicked.emit(event);
  }

  onRowDoubleClicked(event: SohoDataGridRowClicked): void {
    this.rowDoubleClicked.emit(event);
  }

  onSelected(event: SohoDataGridSelectedEvent): void {
    this.selected.emit(event);
  }

  onSettingsChanged(event: SohoDataGridSettingsChangedEvent): void {
    this.settingsChanged.emit(event);
  }

  onSorted(event: SohoDataGridSortedEvent): void {
    this.sorted.emit(event);
  }

  onFilterOperatorChanged(event: SohoDataGridFilterOperatorChangedEvent): void {
    this.filteroperatorchanged.emit(event);
  }

  onExpandRow(event: SohoDataGridToggleRowEvent): void {
    this.expandrow.emit(event);
  }

  onCollapseRow(event: SohoDataGridToggleRowEvent): void {
    this.collapserow.emit(event);
  }
}
